import script from "./AttributeOptionsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttributeOptionsList.vue?vue&type=script&lang=ts&setup=true"

import "./AttributeOptionsList.vue?vue&type=style&index=0&id=79a7ce23&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a7ce23"]])

export default __exports__